import React from 'react';
import { useNavigate } from 'react-router-dom';
import { IoClose } from 'react-icons/io5';
import styles from './Calculator.module.css';
import ProgressBar from './ProgressBar';
import NavigationButtons from './NavigationButtons';
import CalculatorStepRouter from './CalculatorStepRouter';
import { useCalculatorForm } from './hooks/useCalculatorForm';
import { useCalculatorSteps } from './hooks/useCalculatorSteps';
import { useCalculatorSubmission } from './hooks/useCalculatorSubmission';
import { useCalculatorAnalytics } from './hooks/useCalculatorAnalytics';
import { Step } from './calculatorSteps';

export const Calculator: React.FC = () => {
  const navigate = useNavigate();

  const {
    formData,
    selectChallenge,
    toggleService,
    setWorkshopType,
    setTechnologiesText,
    setEmail,
    toggleTerms,
  } = useCalculatorForm();

  const { currentStep, totalSteps, goNext, goBack, goToStep, canAdvance } = useCalculatorSteps(
    formData,
    () => navigate('/'),
  );

  useCalculatorAnalytics(currentStep);

  const { status: submissionStatus, submit } = useCalculatorSubmission({
    onSuccess: () => goToStep(Step.Success),
  });

  const submitForm = () => submit(formData);

  const stepHasOwnActions = currentStep === Step.Estimate || currentStep === Step.Success;

  return (
    <div className={styles.calculator}>
      <div className={styles.headerRow}>
        <ProgressBar currentStep={currentStep} totalSteps={totalSteps} />
        <button className={styles.closeButton} onClick={() => navigate('/')}>
          <IoClose size={24} />
        </button>
      </div>

      <div className={styles.content}>
        <CalculatorStepRouter
          currentStep={currentStep}
          formData={formData}
          submissionStatus={submissionStatus}
          onSelectChallenge={selectChallenge}
          onToggleService={toggleService}
          onSetWorkshopType={setWorkshopType}
          onSetTechnologiesText={setTechnologiesText}
          onEmailChange={setEmail}
          onTermsToggle={toggleTerms}
          onSubmit={submitForm}
          onClose={() => navigate('/')}
        />

        {!stepHasOwnActions && (
          <NavigationButtons
            currentStep={currentStep}
            totalSteps={totalSteps}
            canAdvance={canAdvance}
            onBack={goBack}
            onNext={goNext}
          />
        )}
      </div>
    </div>
  );
};
